import { render, staticRenderFns } from "./FooterBlack.vue?vue&type=template&id=27e0fbe0&scoped=true"
import script from "./FooterBlack.vue?vue&type=script&lang=js"
export * from "./FooterBlack.vue?vue&type=script&lang=js"
import style0 from "./FooterBlack.vue?vue&type=style&index=0&id=27e0fbe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e0fbe0",
  null
  
)

export default component.exports